import React from 'react';

function SkeletonPulse({ className = '' }: { className?: string }) {
  return (
    <div
      className={`skeleton-shimmer-dark ${className}`}
    />
  );
}

export function SkeletonCard({ rows = 3 }: { rows?: number }) {
  return (
    <div className="rounded-xl p-5 space-y-3 border" style={{ background: 'var(--bg-surface-raised)', borderColor: 'var(--border-primary)' }}>
      <div className="flex items-center gap-3">
        <SkeletonPulse className="w-8 h-8 rounded-lg" />
        <SkeletonPulse className="w-32 h-4 rounded" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonPulse key={i} className="w-full h-3 rounded" style={{ width: String(70 + Math.random() * 30) + '%' }} />
      ))}
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="rounded-xl p-5 space-y-3 border" style={{ background: 'var(--bg-surface-raised)', borderColor: 'var(--border-primary)' }}>
      <div className="flex items-center justify-between">
        <SkeletonPulse className="w-24 h-3 rounded" />
        <SkeletonPulse className="w-8 h-8 rounded-lg" />
      </div>
      <SkeletonPulse className="w-20 h-7 rounded" />
      <SkeletonPulse className="w-16 h-3 rounded" />
    </div>
  );
}

export function SkeletonTable({ columns = 6, rows = 5 }: { columns?: number; rows?: number }) {
  return (
    <div className="rounded-xl overflow-hidden border" style={{ background: 'var(--bg-surface-raised)', borderColor: 'var(--border-primary)' }}>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b" style={{ borderColor: 'var(--border-separator)', background: 'var(--bg-input)' }}>
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i} className="px-4 py-3 text-left">
                  <SkeletonPulse className="w-16 h-3 rounded" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, ri) => (
              <tr key={ri} style={{ borderBottom: ri < rows - 1 ? '1px solid var(--border-separator)' : undefined }}>
                {Array.from({ length: columns }).map((_, ci) => (
                  <td key={ci} className="px-4 py-3">
                    <SkeletonPulse className="w-full h-3 rounded" style={{ width: String(40 + Math.random() * 50) + '%', maxWidth: ci === 0 ? '120px' : '80px' }} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function SkeletonList({ rows = 4 }: { rows?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="rounded-xl p-4 flex items-center gap-3 border" style={{ background: 'var(--bg-surface-raised)', borderColor: 'var(--border-primary)' }}>
          <SkeletonPulse className="w-2 h-2 rounded-full shrink-0" />
          <div className="flex-1 space-y-2">
            <SkeletonPulse className="w-32 h-3 rounded" />
            <SkeletonPulse className="w-20 h-2.5 rounded" />
          </div>
          <SkeletonPulse className="w-16 h-3 rounded" />
        </div>
      ))}
    </div>
  );
}

export function SkeletonRow({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <SkeletonPulse className="w-8 h-8 rounded-lg shrink-0" />
      <div className="flex-1 space-y-1.5">
        <SkeletonPulse className="w-32 h-3 rounded" />
        <SkeletonPulse className="w-20 h-2.5 rounded" />
      </div>
    </div>
  );
}